import React from "react";
import { Helmet, HelmetData } from "react-helmet-async";

const HelmetLayout = ({ children, titleProps }) => {
  const helmetData = new HelmetData({});
  return (
    <>
      <Helmet helmetData={helmetData}>
        <title>{`${titleProps} | Swifty Global`}</title>
        {children}
      </Helmet>
    </>
  );
};

export default HelmetLayout;
